var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntrada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#5EBE74"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#EFF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.0586H22M18 11.0586L22 15.0586L18 19.0586",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrada);
export default __webpack_public_path__ + "static/media/Entrada.2a8ce6d250992952a17c299b6f90c136.svg";
export { ForwardRef as ReactComponent };